"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_DICTATE_STATE = void 0;
exports["default"] = setDictateState;
var SET_DICTATE_STATE = 'WEB_CHAT/SET_DICTATE_STATE';
exports.SET_DICTATE_STATE = SET_DICTATE_STATE;
function setDictateState(dictateState) {
  return {
    type: SET_DICTATE_STATE,
    payload: {
      dictateState: dictateState
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfRElDVEFURV9TVEFURSIsImV4cG9ydHMiLCJzZXREaWN0YXRlU3RhdGUiLCJkaWN0YXRlU3RhdGUiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldERpY3RhdGVTdGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfRElDVEFURV9TVEFURSA9ICdXRUJfQ0hBVC9TRVRfRElDVEFURV9TVEFURSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldERpY3RhdGVTdGF0ZShkaWN0YXRlU3RhdGUpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfRElDVEFURV9TVEFURSxcbiAgICBwYXlsb2FkOiB7IGRpY3RhdGVTdGF0ZSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9ESUNUQVRFX1NUQVRFIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxpQkFBaUIsR0FBRyw0QkFBNEI7QUFBQ0MsT0FBQSxDQUFBRCxpQkFBQSxHQUFBQSxpQkFBQTtBQUV4QyxTQUFTRSxlQUFlQSxDQUFDQyxZQUFZLEVBQUU7RUFDcEQsT0FBTztJQUNMQyxJQUFJLEVBQUVKLGlCQUFpQjtJQUN2QkssT0FBTyxFQUFFO01BQUVGLFlBQVksRUFBWkE7SUFBYTtFQUMxQixDQUFDO0FBQ0gifQ==